import React from 'react';

const BnplTerms = ({ className }) => {
  return (
    <div className={className}>
      <div className={`${className}__title`}>
        <h1>Terms & Conditions</h1>
      </div>
      <div className={`${className}__divider`} />
      <div className={`${className}__article`}>
        <div className={`${className}__article__title`}>Article</div>
        <div className={`${className}__article__text`}>
          Ipsum velit sit ultrices sed eget quisque non. Porttitor non, consectetur lectus
          pellentesque consequat. Risus leo mattis vestibulum eleifend. Nunc, arcu elementum non et
          integer enim. Porttitor elementum tempor, viverra tortor sit etiam vel proin imperdiet.
        </div>
      </div>
      <div className={`${className}__article`}>
        <div className={`${className}__article__title`}>Article</div>
        <div className={`${className}__article__text`}>
          Ipsum velit sit ultrices sed eget quisque non. Porttitor non, consectetur lectus
          pellentesque consequat. Risus leo mattis vestibulum eleifend. Nunc, arcu elementum{' '}
        </div>
      </div>
    </div>
  );
};

export default BnplTerms;
